import {
    FilterParam,
    PageableParam, SortParam,
    StorageConfigUpdateInput,
    useCurrentBoxtypesQuery,
    useCurrentPackagetypesQuery,
    useCurrentStorageconfigsQuery, useFuelLevelStatQueryQuery, useGetBoxesPerRackQuery,
    useGetCurrentBoxTypeQuery,
    useGetCurrentStorageconfigQuery, useGetMaterialsQuery, useGetPickZonesQuery,
    useUpdateStorageConfigQueryMutation
} from '../api/models'

const getContext = (token: string | undefined) => {
    return {
        headers: {
            Authorization: `Bearer ${token || 'unknown'}`,
        }
    }
}

interface usePackagetypesProps {
    pagination: PageableParam
    sort: SortParam[]
    q: string | null
    filter: FilterParam[]
}

interface useMaterialQueryProps {
    pagination: PageableParam
    sort: SortParam[]
    q: string | null
    filter: FilterParam[]
}

interface useQueryProps {
    pagination: PageableParam
    sort: SortParam[]
    q: string | null
    filter: FilterParam[]
}

interface useBoxtypeProps {
    uuid: string
}

interface useStorageconfigsProps {
    page: number
    size: number
}

interface useStorageconfigProps {
    uuid: string
}

interface useBoxesPerRackProps {
    uuid: string
}

interface useUpdateStorageconfigProps {
    uuid: string
    config: StorageConfigUpdateInput
}


export const usePackagetypes = (token: string | undefined, params: usePackagetypesProps) => {
    const { pagination, sort, q, filter } = params
    return useCurrentPackagetypesQuery({ context: getContext(token), variables: { pagination, sort, q, filter }})
}

export const useMaterials = (token: string | undefined, params: useMaterialQueryProps) => {
    const { pagination, sort, q, filter } = params
    return useGetMaterialsQuery({ context: getContext(token), variables: { pagination, sort, q, filter }})
}

export const usePickZones = (token: string | undefined, params: useQueryProps) => {
    const { pagination, filter } = params
    return useGetPickZonesQuery({ context: getContext(token), variables: { pagination, filter } })
}

export const useBoxtypes = (token: string | undefined, params: useQueryProps) => {
    const { pagination, filter, sort } = params
    return useCurrentBoxtypesQuery({ context: getContext(token), variables: { pagination, filter, sort } })
}

export const useCurrentBoxtype = (token: string | undefined, params: useBoxtypeProps) => {
    const { uuid } = params
    return useGetCurrentBoxTypeQuery({ context: getContext(token), variables: { id: uuid}})
}

export const useStorageconfigs = (token: string | undefined, params: useStorageconfigsProps) => {
    const { page, size } = params
    return useCurrentStorageconfigsQuery({ context: getContext(token), variables: { pagination: { page, size } } })
}

export const useCurrentStorageconfig = (token: string | undefined, params: useStorageconfigProps) => {
    const { uuid } = params
    return useGetCurrentStorageconfigQuery({ context: getContext(token), variables: { id: uuid}})
}

export const useUpdateCurrentStorageconfig = (token: string | undefined, params: useUpdateStorageconfigProps) => {
    const { uuid, config } = params
    return useUpdateStorageConfigQueryMutation({ context: getContext(token), variables: { id: uuid, config: config}})
}

export const useCurrentBoxesPerRack = (token: string | undefined, params: useBoxesPerRackProps) => {
    const { uuid } = params
    const { data, loading, error } = useGetBoxesPerRackQuery({
        context: {
            headers: {
                Authorization: `Bearer ${token || 'unknown'}`,
            },
        },
        variables: { zone: uuid}
    })
    return { boxesData: data, boxesLoading: loading, boxesError: error }
}
